'use client';

import Image from 'next/image';

import { motion } from 'framer-motion';

import bildderfrauLogo from '~/assets/images/logos/bildderfrau.svg';
import eceLogo from '~/assets/images/logos/ece.svg';
import editionfLogo from '~/assets/images/logos/editionf.svg';
import funkeLogo from '~/assets/images/logos/funke.svg';
import gofemininLogo from '~/assets/images/logos/gofeminin.svg';
import icsLogo from '~/assets/images/logos/ics.webp';
import identivLogo from '~/assets/images/logos/identiv.svg';
import kaudasLogo from '~/assets/images/logos/kaudas.png';
import sirplusLogo from '~/assets/images/logos/sirplus.webp';
import sportfiveLogo from '~/assets/images/logos/sportfive.svg';
import t3nLogo from '~/assets/images/logos/t3n.svg';
import vickiiLogo from '~/assets/images/logos/vickii.webp';
import webediaLogo from '~/assets/images/logos/webedia.svg';

import Marquee from '../magicui/marquee';
import Section from '../section';

const companies = [
  {
    name: 'Gofeminin',
    link: '#',
    width: 120,
    height: 60,
    src: gofemininLogo,
  },
  {
    name: 'Bild Der Frau',
    link: '#',
    width: 120,
    height: 90,
    src: bildderfrauLogo,
  },
  {
    name: 'Edition F',
    link: '#',
    width: 120,
    height: 60,
    src: editionfLogo,
  },
  {
    name: 'ECE',
    link: '#',
    width: 80,
    height: 60,
    src: eceLogo,
  },
  {
    name: 'Funke',
    link: '#',
    width: 120,
    height: 60,
    src: funkeLogo,
  },
  {
    name: 'Sportfive',
    link: '#',
    width: 120,
    height: 60,
    src: sportfiveLogo,
  },
  {
    name: 'T3n',
    link: '#',
    width: 120,
    height: 60,
    src: t3nLogo,
  },
  {
    name: 'Kaudas',
    link: '#',
    width: 60,
    height: 60,
    src: kaudasLogo,
  },
  {
    name: 'Internationale Computerspielesammlung',
    link: '#',
    width: 120,
    height: 40,
    src: icsLogo,
  },
  {
    name: 'Identiv',
    link: '#',
    width: 60,
    height: 60,
    src: identivLogo,
  },
  {
    name: 'SirPlus',
    link: '#',
    width: 160,
    height: 48.3,
    src: sirplusLogo,
  },
  {
    name: 'Vickii',
    link: '#',
    width: 160,
    height: 40,
    src: vickiiLogo,
  },
  {
    name: 'Webedia',
    link: '#',
    width: 60,
    height: 60,
    src: webediaLogo,
  },
];

export default function Logos({ heading }: { heading?: string }) {
  return (
    <Section id="logos" className="py-16">
      <div className="relative">
        <motion.h2
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="text-center text-lg tracking-tighter text-[#e6e6e6] lg:text-2xl lg:font-semibold lg:tracking-normal"
        >
          {heading}
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="relative mt-8 lg:mt-12"
        >
          <Marquee className="max-w-full [--duration:40s]">
            {companies.map((company, idx) => (
              <Image
                key={idx}
                src={
                  company.src ??
                  `https://cdn.magicui.design/companies/${company.name}.svg`
                }
                className="h-10 w-40 object-contain object-center px-2 brightness-0 invert"
                alt={company.name}
                width={company.width}
                height={company.height}
              />
            ))}
          </Marquee>
          <div className="pointer-events-none absolute inset-y-0 left-0 h-full w-1/3 bg-gradient-to-r from-landing-background"></div>
          <div className="pointer-events-none absolute inset-y-0 right-0 h-full w-1/3 bg-gradient-to-l from-landing-background"></div>
        </motion.div>
      </div>
    </Section>
  );
}
